import React from "react";

function OnBoardConsultants() {
  const consultants = [
    {
      title: "STRUCTURAL CONSULTANT",
      company: "Nirman Engineering Consultants Pvt Ltd",
    },
    {
      title: "SERVICE CONSULTANT",
      company: "Maverick Engineering Consultant Pvt Ltd",
    },
    {
      title: "LIGHTING CONSULTANT",
      company: "ATPL Lighting",
    },
  ];

  return (
    <section className="consultants-sec">
      <div className="container">

        <div className="section-head text-center">
          <h2>On-Board Consultants</h2>
        </div>

        <div className="row justify-content-center">

          {consultants.map((item, index) => (
            <div className="col-lg-3 col-md-6 mb-4 d-flex" key={index}>

              <div className="consultant-box w-100">

                <h6>{item.title}</h6>

                <h4>{item.company}</h4>

              </div>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
}

export default OnBoardConsultants;